import React from "react";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import PdfViewerCard from "../../PdfViewerCard";
import polizas, { tituloPoliza } from "./polizas";
import "../../incidentes.css";

const Poliza = () => {
  const { slug } = useParams();
  const poliza = polizas.find((p) => p.slug === slug);

  if (!poliza) {
    return (
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Póliza no encontrada</h1>
        </div>
      </Container>
    );
  }

  const titulo = tituloPoliza(poliza);
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/${poliza.pdf}`;

  return (
    <Container fluid className="background-containerr">
      <div className="orgproc-header">
        <h1 className="orgproc-heading">{titulo}</h1>
      </div>
      <PdfViewerCard pdfUrl={pdfUrl} titulo={titulo} />
    </Container>
  );
};

export default Poliza;
